export class PlatformMetaKeyUtils {
  static isMac(): boolean {
    try {
      return (
        navigator.platform?.toLowerCase()?.includes('mac') ||
        navigator.userAgent?.toLowerCase()?.includes('mac')
      );
    } catch {
      return false;
    }
  }

  static parseMetaKey(shortcut: string): string {
    if (!PlatformMetaKeyUtils.isMac() && shortcut.includes('Meta')) {
      return shortcut.replace('Meta', 'Control');
    }
    return shortcut;
  }

  static getMetaKey(): string {
    return PlatformMetaKeyUtils.isMac() ? '⌘' : 'Ctrl';
  }
}
